import React from 'react';


import ProfileBottomNavigation from '../../navigation/ProfileBottomNavigation';
import ProfileTopNavigation from '../../navigation/ProfileTopNavigation';
import BottomNavigation from '../../navigation/BottomNavigation';

const ProfileTopbar = (props) => {




    return (
        <div>
            <ProfileTopNavigation {...props} themeColor="light"></ProfileTopNavigation>
            <BottomNavigation {...props}></BottomNavigation>
        </div>


    );
};

export default ProfileTopbar;
